import React, { useCallback } from 'react';
import UI from '../../../ui';
import StateIcon from '../../../ui/icon/StateIcon.component';
import Session from '../../../utils/Session';

const { WrappedButton, WrappedButtonType } = UI;

export const Guidelines = ({ isUSPSAccountCreated }) => {
	const GUIDELINE_STEPS = [
		{
			id: 'access',
			content:
				'To access your contract rates, you first need a USPS Business Account with a linked payment method (EPA).',
		},
		{
			id: 'portal',
			content: (
				<>
					Tap the link below to go to the <strong>USPS portal</strong>. Follow
					the setup wizard to create your account and/or add your payment
					method.
				</>
			),
		},
		{
			id: 'note',
			content: (
				<>
					<strong>Note:</strong> Although adding a payment method may appear
					&quot;optional&quot;, it is mandatory to finalize your connection with
					Auctane.
				</>
			),
		},
		{
			id: 'continue',
			content: 'Then, continue to the next step below.',
		},
	];

	const handleSetupAccountClick = useCallback(() => {
		const sessionData = Session.getData();
		const { settings } = sessionData;

		window.open(settings.UspsCopUrl, '_blank', 'noopener,noreferrer');
	}, []);

	const sectionClassName = `guidelines-section guidelines-section--${isUSPSAccountCreated ? 'completed' : 'todo'}`;

	const buttonConfig = {
		buttonType: WrappedButtonType.Primary,
		label: 'Setup Your USPS Business Account',
		dataqa: 'setup-usps-business-account-button',
	};

	return (
		<section className="usps-guidelines">
			<article className={sectionClassName}>
				<header className="guideline-header">
					<StateIcon isCompleted={isUSPSAccountCreated} />
					<h4 id="create-account-heading">New to USPS?</h4>
				</header>

				<p className="guideline-subtitle">
					Create Your Account &amp; Setup Your EPA
				</p>

				<ol className="guideline-steps">
					{GUIDELINE_STEPS.map(step => (
						<li key={step.id}>{step.content}</li>
					))}
				</ol>

				<footer className="guideline-action">
					<WrappedButton
						{...buttonConfig}
						onClick={handleSetupAccountClick}
						aria-label={`${buttonConfig.label} (opens in new tab)`}
					/>
				</footer>
			</article>
		</section>
	);
};
